import { URLS } from "@/define";
import { useUserStore } from "@/stores/user";
import { useSiteSettingsStore } from "@/stores/siteSettings";
import { clearSession as pendoClearSession } from "./pendo";

export const logoutURL = `${URLS.UP_ENDPOINT.protocol}://${URLS.UP_ENDPOINT.hostname}/api/cp/auth/logout`;

export async function clearSession() {
  await pendoClearSession(); // Clear session from Pendo
  const siteSettingsStore = useSiteSettingsStore();
  siteSettingsStore.setIsCreateAccountFlow(false);
  siteSettingsStore.setShowedVerifyEmailDialogAfterCreateAccountFlow(false);
  siteSettingsStore.setSubscriberRefreshedAfterLogin(false);
  siteSettingsStore.reset();

  const userStore = useUserStore();
  const currentLanguage = userStore.selectedLanguage;
  userStore.resetState();
  userStore.selectedLanguage = currentLanguage;
}

export async function redirectToLogoutURL() {
  window.location.href = logoutURL;
}

export async function logout() {
  await clearSession();
  redirectToLogoutURL();
}
